/**
 * Central Formatting Utilities for Inspect AI
 * Proteção rigorosa contra "undefined", "null", "[object Object]"
 */

export function formatWorkOrderLabel(wo: any): string {
  if (!wo) return '';
  const code = wo.code ? String(wo.code).trim() : '';
  const desc = wo.description ? String(wo.description).trim() : (wo.title ? String(wo.title).trim() : '');
  
  const parts = [code, desc].filter(Boolean);
  return parts.length > 0 ? parts.join(' - ') : (wo.id || '');
}

export function formatSubWorkOrderLabel(sub: any): string {
  if (!sub) return '';
  const code = sub.code ? String(sub.code).trim() : '';
  const desc = sub.description ? String(sub.description).trim() : (sub.title ? String(sub.title).trim() : '');
  
  const parts = [code, desc].filter(Boolean);
  return parts.length > 0 ? parts.join(' - ') : (sub.id || '');
}

export function formatProjectLabel(project: any): string {
  if (!project) return '';
  const code = project.code ? String(project.code).trim() : '';
  const name = project.name ? String(project.name).trim() : '';
  
  const parts = [code, name].filter(Boolean);
  return parts.length > 0 ? parts.join(' - ') : (project.id || '');
}

export function formatUnitAreaLabel(unit: any): string {
  if (!unit) return '';
  const code = unit.code ? String(unit.code).trim() : '';
  const name = unit.name ? String(unit.name).trim() : '';
  
  const parts = [code, name].filter(Boolean);
  return parts.length > 0 ? parts.join(' - ') : (unit.id || '');
}
